import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=554851f6&"
import script from "./ImportFile.vue?vue&type=script&lang=js&"
export * from "./ImportFile.vue?vue&type=script&lang=js&"
import style0 from "./ImportFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports